import { defaultCategoryList } from '../../../shared/Vendors/VendorsCategory/mapVendorCategories';
import flags from '../../../../shared/Flags';
import GenericVendors from '../../../shared/Vendors/Generic/GenericVendors';
import Pagination from '../../../../shared/Pagination';
import paths from '../../../../config/local/paths';
import React, { useState } from 'react';
import useGetAgentVendors from '../../../../Hooks/Agent/Getters/useGetAgentVendors/useGetAgentVendors';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';
import VendorsCategory from '../../../shared/Vendors/VendorsCategory/VendorsCategory';
import VendorsTable from '../../../shared/Vendors/VendorsTable/VendorsTable';

/** @returns {JSX.Element} */
export default function AgentVendors() {
	const [category, setCategory] = useState(Object.keys(defaultCategoryList)[0]); // prettier-ignore
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const { isGated, isGettingData } = useIsGated(flags.vendor.add);
	const vendors = useGetAgentVendors(category, currentPageNumber, isGated);

	if (isGated) {
		return (
			<GenericVendors
				isGettingData={isGettingData}
				link={paths.app.agent.subscription.root}
				userRole="agent"
			/>
		);
	}

	return (
		<React.Fragment>
			<VendorsCategory
				categories={vendors.categories}
				isGettingData={vendors.isGettingData}
				onSelectCategory={setCategory}
			/>

			<VendorsTable
				editPath={paths.app.agent.offers.edit}
				isGettingData={vendors.isGettingData}
				vendors={vendors.data}
			/>

			<Pagination
				currentPageNumber={currentPageNumber}
				lastPageNumber={vendors.lastPageNumber}
				setCurrentPageNumber={setCurrentPageNumber}
			/>
		</React.Fragment>
	);
}
